import {
  apiResumenPago,

  apiCuotasPago,
  apiListadoBancos,
  codigoApp,
  apiGeneracionCuenta,
  apiCreaModalidad,
  apiModalidadPagos,
  apiPagoCuotasPendientes,
  apiValidacionEstadoPago,
  apiUpdateDatosPago,

  apiValidacionEstadoPagoMatricula,
} from "../config/constantes";

const prometeValidarApi = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config).then((data) => {

      if (data.status == 200 || data.status == 400) {
        resolver(data);
      } else {
        rechazar(new Error(data));
      }
    });
  });
};
let cuotasPagoService = (
  datosEstudiante,
  setCuotasPagosEstudiante,
  setLoading,
  param_tipo,
  dperiodo
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { ndocidentidad } =
    datosEstudiante;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },


      body: JSON.stringify({
        param_cod_per: String(ndocidentidad),
        param_tipo: Number(param_tipo),
        param_periodo: dperiodo
      }),
    };


    setLoading(true);
    fetch(apiCuotasPago, config).then((data) => {

      if (data.status == 200 || data.status == 400) {
        return data
      } else {
        throw data;
      }
    }).then(data => {


      return data.json();

    }).then(list => {
      const { Data } = list;

      setCuotasPagosEstudiante(Data);
      setLoading(false);
    })




  }
};
let resumenPagoEstudianteService = async (
  datosEstudiante,
  ncuota,
  setResumenPagoEstudiante,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona, ndocidentidad } =
    datosEstudiante;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },

      body: JSON.stringify({
        param_cod_per: String(ndocidentidad),
        param_nro_cuotas: Number(ncuota),

      }),
    };
    try {
      setLoading(true);
      const lstResumenPago = await prometeValidarApi(
        `${apiResumenPago}`,
        config
      );
      const lstResumenPagoJson = await lstResumenPago.json();
      const { Data } = lstResumenPagoJson;
      setResumenPagoEstudiante(Data);

    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  }
};


let listaPensionesCuotasPendientes = async (
  seguros,
  setPensionesEstudiante,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { ndocidentidad, carritoSeguro } = seguros;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cusuario: String(ndocidentidad),
        p_seguro: Number(carritoSeguro),
      }),
    };
    try {
      setLoading(true);
      const lstPensionesEstudiante = await prometeValidarApi(
        `${apiPagoCuotasPendientes}`,
        config
      );

      const lstPensionesEstudianteJson = await lstPensionesEstudiante.json();
      const { Data } = lstPensionesEstudianteJson;
      setPensionesEstudiante(Data);

    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  }
};

let insertar_generacion_cuenta = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { ndocidentidad, cinstitucion, cprograma, ccarrera, scarrera, cperiodo,
    dperiodo, calumno
  } = datosEstudiante;
  const { stCuotaSelecionada } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },

      body: JSON.stringify({
        param_cod_per: ndocidentidad,
        param_nro_cuotas: Number(stCuotaSelecionada),
        cinstitucion: cinstitucion,
        cprograma: cprograma,
        ccarrera: ccarrera,
        scarrera: scarrera,
        cperiodo: cperiodo,
        speriodo: dperiodo,
        calumno: calumno
      }),
    };

    try {
      const insertarGeneracionCuenta = await prometeValidarApi(
        `${apiGeneracionCuenta}`,
        config
      );

      const insertarGeneracionCuentaJson =
        await insertarGeneracionCuenta.json();
      const { Data } = insertarGeneracionCuentaJson;

      return insertarGeneracionCuentaJson

    } catch (error) {
      throw error;
    }
  }
};

let insertar_modalidad_pago = async (
  datosEstudiante,
  inputs,
  resumenPagoEstudiante
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cpersona, cinstitucion, cprograma, cperiodo } = datosEstudiante;
  const {
    monto_matricula,
    monto_semestral,
    monto_otros,
    total_neto_semestral,
    primer_monto,
    cuotas_restante,
    valor_cuota,
    norden,
  } = resumenPagoEstudiante;
  const { stCuotaSelecionada } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_ccuota: Number(stCuotaSelecionada),
        p_norden: Number(norden),
        p_monto_matricula: Number(monto_matricula),
        p_monto_semestral: Number(monto_semestral),
        p_monto_otros: Number(monto_otros),
        p_neto_semestral: Number(total_neto_semestral),
        p_primer_monto: Number(primer_monto),
        p_cuotas_restante: Number(cuotas_restante),
        p_valor_cuota: Number(valor_cuota),
      }),
    };

    try {


      const insertarModalidadPago = await prometeValidarApi(
        `${apiCreaModalidad}`,
        config
      );

      const insertarModalidadPagoJson = await insertarModalidadPago.json();
      const { Data } = insertarModalidadPagoJson;

      return insertarModalidadPagoJson;

    } catch (error) {
      throw error;
    }
  }
};

let listaBancos = async (datosEstudiante, setListadoBancos) => {
  const { cinstitucion } = datosEstudiante;
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_caplicacion: Number(codigoApp),
      }),
    };
    try {
      const listBancos = await prometeValidarApi(`${apiListadoBancos}`, config);

      const listBancosJson = await listBancos.json();
      const { Data } = listBancosJson;
      setListadoBancos(Data);

    } catch (error) { }
  }
};


let listaModalidadPagos = async (
  datosEstudiante,
  setListadoModalidadPagos,
  setLoading
) => {
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
      }),
    };
    try {
      setLoading(true);
      const listModalidadPagos = await prometeValidarApi(
        `${apiModalidadPagos}`,
        config
      );

      const listModalidadPagosJson = await listModalidadPagos.json();
      const { Data } = listModalidadPagosJson;
      setListadoModalidadPagos(Data);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};



let apiTokenDePagoTiendaUpch = async (ndocidentidad, setLoading) => {



  var myHeaders = new Headers();
  myHeaders.append("Authorization", "upch bb665ad1-0350-4dd5-88ea-2ed9bce62fdb");
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("client_id", "APP-4X58TOHYJ9XTTSJS");
  urlencoded.append("response_type", "code");
  urlencoded.append("scope", "/authenticate");
  urlencoded.append("codper", `${ndocidentidad}`);


  const config = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  };
  try {
    setLoading(true);

  } catch (error) {
    setLoading(false);
    throw new error
  } finally {
    setLoading(false);
  }
}

let validacionEstadoPago = async (
  dperiodo,
  calumno,
  ndocidentidad,
  setLoading
) => {

  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        param_cod_per: String(ndocidentidad),
        param_periodo: String(dperiodo),
        param_id_alum_programa: Number(calumno),
      }),
    };
    try {
      setLoading(true);
      const validacionEstadoPago = await prometeValidarApi(
        `${apiValidacionEstadoPago}`,
        config
      );

      const validacionEstadoPagoJson = await validacionEstadoPago.json();

      return validacionEstadoPagoJson

    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};

let validacionEstadoPagoMatricula = async (
  dperiodo,
  sprograma,
  ndocidentidad,
  setLoading
) => {

  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_nro_documento: String(ndocidentidad),
        p_periodo: String(dperiodo),
        p_carrera: sprograma
      }),
    };
    try {
      setLoading(true);
      const validacionEstadoPago = await prometeValidarApi(
        `${apiValidacionEstadoPagoMatricula}`,
        config
      );

      const validacionEstadoPagoJson = await validacionEstadoPago.json();

      return validacionEstadoPagoJson

    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};

let updateDatosPago = async (
  datosEstudiante,
  setLoading,
  pasosPa
) => {
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  const { paso, pasoPago } = pasosPa
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_paso: Number(paso),
        p_pasopago: Number(pasoPago),
      }),
    };
    try {
      setLoading(true);
      const updateDatosPago = await prometeValidarApi(
        `${apiUpdateDatosPago}`,
        config
      );

      const updateDatosPagoJson = await updateDatosPago.json();

      return updateDatosPagoJson
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};

let validarSeguroUpch = async (
  datosEstudiante,
  setValidarSeguro,
  setLoading
) => {
  const { cpersona } = datosEstudiante;
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpersona: Number(cpersona),
      }),
    };
    try {
      setLoading(true);
      const listValidarSeguro = await prometeValidarApi(
        `${apiValidacionEstadoPago}`,
        config
      );

      const listValidarSeguroJson = await listValidarSeguro.json();
      const { Data } = listValidarSeguroJson;
      setValidarSeguro(Data);

    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
};



export {
  cuotasPagoService,
  resumenPagoEstudianteService,
  insertar_modalidad_pago,
  listaBancos,
  insertar_generacion_cuenta,
  listaModalidadPagos,
  listaPensionesCuotasPendientes,
  apiTokenDePagoTiendaUpch,
  validacionEstadoPago,
  validacionEstadoPagoMatricula,
  updateDatosPago,
  validarSeguroUpch

};
